import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * As we use an existing SVG to power SYOS,
 * rather than rendering on the fly, this is
 * the one part of the App which diverges from
 * traditional React components, so most of the
 * behaviour here is done through manual DOM
 * manipulation and triggering custom events.
 *
 * This component just renders the HTML.
 * Most of the work happens in `SeatMapContainer`
 * and inside `behaviours/enhanceSeats`.
 */
class SeatMap extends Component {
  render() {
    let svgData = this.props.svgData;

    /* eslint-disable react/no-danger */
    return svgData ? (
      <div
        ref={component => {
          this._seatmap = component;
          this._seatmapSvg = component && component.querySelector('svg');
          this._seats =
            component && component.querySelectorAll("#seatmap [id^='seat-']");
          this._levels =
            component && component.querySelectorAll('#seatmap > g');
        }}
        className={classnames({
          'syos-seatmap': true,
          'is-ready': this.props.isEnhanced
        })}
        dangerouslySetInnerHTML={{
          __html: svgData
        }}
      />
    ) : null;
  }
}
SeatMap.propTypes = {
  svgData: PropTypes.string,
  isEnhanced: PropTypes.bool
};

export default SeatMap;



// WEBPACK FOOTER //
// ./src/javascripts/components/SeatMap.js